<button class="notification-button" [ngClass]="notificationButtonElement?.style">
    <app-icon-message-toaster-element [iconString]="notificationButtonElement?.title">
    </app-icon-message-toaster-element>
  </button>